<div class="auth-wrapper auth-v1 px-2">
  <div class="auth-inner py-2">
    <!-- Register v1 -->
    <div class="card mb-0">
      <div class="card-header justify-content-center bg-secondary">
        <a href="#" target="_self" class="brand-logo mb-0 mt-0">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="50"/>
        </a>
      </div>
      <div class="card-body pt-2">
        <h4 class="card-title mb-1">Ti diamo il benvenuto!</h4>
        <p class="card-text mb-2">Con questo account potrai accedere ai nostri servizi</p>

        <form class="auth-register-form mt-2" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="form-group col-6">
              <label for="register-name" class="form-label">Nome</label>
              <input
                type="text"
                formControlName="name"
                class="form-control"
                placeholder="Nome"
                aria-describedby="register-name"
                tabindex="1"
                autofocus
                [ngClass]="{ 'is-invalid': submitted && f.name.errors }"
                id="register-name"
              />
              <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                <div *ngIf="f.name.errors.required">il nome è obbligatorio</div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="register-surname" class="form-label">Cognome</label>
              <input
                type="text"
                formControlName="surname"
                class="form-control"
                placeholder="Cognome"
                aria-describedby="register-surname"
                tabindex="1"
                autofocus
                [ngClass]="{ 'is-invalid': submitted && f.surname.errors }"
                id="register-surname"
              />
              <div *ngIf="submitted && f.surname.errors" class="invalid-feedback">
                <div *ngIf="f.surname.errors.required">il cognome è obbligatorio</div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="register-email" class="form-label">Email</label>
            <input
              type="text"
              formControlName="email"
              class="form-control"
              placeholder="john@example.com"
              aria-describedby="register-email"
              tabindex="1"
              [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
              id="register-email"
            />
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
              <div *ngIf="f.email.errors.required">l'e-mail è obbligatoria</div>
              <div *ngIf="f.email.errors.email">L'e-mail deve essere un indirizzo e-mail valido</div>
            </div>
          </div>
          <div class="form-group">
            <label for="register-phone" class="form-label">Numero di telefono</label>
            <input
              type="text"
              formControlName="phoneNumber"
              class="form-control"
              placeholder="Numero di telefono"
              aria-describedby="register-phone"
              tabindex="1"
              autofocus
              [ngClass]="{ 'is-invalid': submitted && f.phoneNumber.errors }"
              id="register-phone"
            />
            <div *ngIf="submitted && f.phoneNumber.errors" class="invalid-feedback">
              <div *ngIf="f.phoneNumber.errors.required">il numero di telefono è obbligatorio</div>
            </div>
          </div>
          <div class="form-group">
            <label for="register-username" class="form-label" [ngClass]="{ 'is-invalid-label': submitted && f.username.errors || userExist}">Username</label>
            <input
              formControlName="username"
              class="form-control"
              placeholder="johndoe"
              aria-describedby="register-username"
              tabindex="1"
              autofocus
              id="register-username"
              [ngClass]="{ 'is-invalid': submitted && f.username.errors || userExist}"

            />

            <div *ngIf="userExist" class="invalid-feedback">
              <div>Username già in uso </div>
            </div>
            <div *ngIf="registerForm.get('username').errors?.required" class="invalid-feedback">
              <div>Username is required</div>
            </div>
          </div>



          <div class="form-group">
            <label for="register-password" class="form-label">Password</label>

            <div class="input-group input-group-merge form-password-toggle">
              <input
                [type]="passwordTextType ? 'text' : 'password'"
                formControlName="password"
                class="form-control form-control-merge"
                placeholder="············"
                aria-describedby="register-password"
                tabindex="3"
                [ngClass]="{ 'is-invalid error': submitted && f.password.errors }"
                id="register-password"
              />
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer"
                ><i
                  class="feather font-small-4"
                  [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }"
                  (click)="togglePasswordTextType()"
                ></i
                ></span>
              </div>
            </div>
            <div
              *ngIf="submitted && f.password.errors"
              class="invalid-feedback"
              [ngClass]="{ 'd-block': submitted && f.password.errors }"
            >
              <div *ngIf="f.password.errors.required">Password is required</div>
            </div>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input class="custom-control-input" type="checkbox" id="register-privacy-policy" tabindex="4"/>
              <label class="custom-control-label" for="register-privacy-policy">
                Accetto <a href="javascript:void(0);">l'informativa sulla privacy e i termini</a>
              </label>
            </div>
          </div>
          <button class="submit" type="submit">Registrati</button>
        </form>

        <p class="text-center mt-2">
          <span>Hai già un account? </span>
          <a routerLink="/authentication/login">
            <span> Accedi</span>
          </a>
        </p>
      </div>
    </div>
  </div>
</div>


<ng-template #registrationProblemModal let-modal>
  <div class="modal-header bg-primary">
    <h5 class="modal-title text-white pt-1" id="tulero-token-cart-modal">Problemi di Registrazione</h5>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ validationErrorMessage }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cross click')">Chiudi</button>
  </div>
</ng-template>
